import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { CaseMachineStateDescriptor } from './model/case';

@Injectable()
export class CaseMachineService extends RESTServiceBase {

  constructor(authService: AuthService, config: AppConfig) {
    super(
      'v1',
      'CaseMachineManagement',
      authService,
      config.CAMSConfig
    );
  }

  public async getExpectedStates(caseId: string): Promise<CaseMachineStateDescriptor[]> {
    return super.get<CaseMachineStateDescriptor[]>(caseId);
  }

  public async set(caseId: string, state: CaseMachineStateDescriptor): Promise<void> {
    return super.patch<any>(caseId, state);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/case/case.machine.service.ts